module.exports = __webpack_public_path__ + "media/alex.ecd71552.mp4";